import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import Detail from "../../../components/Details";
import SpinnerDot from "../../../components/SpinnerDot";

function Parts() {
  const navigate = useNavigate();

  const { data: parts } = useQuery("parts", () => {
    return fetch(`${process.env.REACT_APP_SERVER_ENDPOINT}/parts`).then((res) =>
      res.json()
    );
  });

  const handlePlaceOrder = (_id) => {
    navigate(`/purchase/${_id}`);
  };

  return (
    <section className="flex flex-wrap gap-8 justify-evenly p-12">
      {!parts ? (
        <SpinnerDot />
      ) : (
        parts.map(
          ({
            _id,
            name,
            imgUrl,
            description,
            minQuantity,
            quantity,
            price,
          }) => (
            <div
              key={_id}
              class="card w-full sm:w-[47.5%] lg:w-[30%] bg-base-100 shadow-xl"
            >
              <figure>
                <img src={imgUrl} alt={name} />
              </figure>

              <div class="card-body justify-between">
                <h2 class="card-title">{name}</h2>
                <p className="flex-grow-0">{description}</p>

                <div className="text-center">
                  <Detail name="Minimum Quantity" value={minQuantity} />
                  <Detail name="Available Quntity" value={quantity} />
                  <Detail name="Price Per Unit" value={`$${price}`} />
                </div>

                <div class="card-actions justify-end">
                  <button
                    onClick={() => {
                      handlePlaceOrder(_id);
                    }}
                    class="btn btn-primary"
                  >
                    Place Order
                  </button>
                </div>
              </div>
            </div>
          )
        )
      )}
    </section>
  );
}

export default Parts;
